<template>
  <div class="article">
    <div v-if="show">
      <h3 class="h3">{{ article.title }}</h3>
      <div class="source"><span class="s-1">沃隆科技</span><span class="s-2">{{ article.created_at }}</span></div>
      <div class="content" v-html="article.content"></div>
    </div>

    <Laod ref="laoding" />
  </div>
</template>

<script>
  import { Cell  } from 'vant'
  import wx from 'weixin-jsapi'

  export default {
    components: {
      [Cell.name]: Cell
    },
    name: 'Scheme',
    data() {
      return {
        show: false,
        article: [],
      };
    },
    created() {
      this.getDetails()
      let shareLink = window.location.href
      this.getJssdkConfig("onMenuShareTimeline,checkJsApi,onMenuShareAppMessage",false,false,shareLink);
    },
    methods: {
      getDetails() {
        const regex = new RegExp('<img', 'gi')
        this.$api.get('scheme/details', {id: this.$route.query.id}, r=>{
          this.article = r.data
          document.title = this.article.title
          let content = this.article.content
          this.article.content = content.replace(regex, `<img style="max-width: 100%; height: auto;display: block;"`)
          this.show = true
          this.$refs.laoding.loadClose()
        })
      },
      getJssdkConfig(apis,debug,json,link){
        let self = this
        this.$api.get('jssdkConfig', {apis:apis, debug:debug, json:json, url: link}, r=>{
          let config = JSON.parse(r.data)
          wx.config(config)
          wx.ready(function() {
            var shareData = {
              title: self.article.share_title,
              desc: self.article.share_brief,
              link: self.article.link,
              imgUrl: self.article.thumbnail,
              success: function () {
                self.$api.get('scheme/shareHits', {id: self.article.id}, r=>{})
              }
            }
            wx.showOptionMenu()
            wx.onMenuShareAppMessage(shareData)
            wx.onMenuShareTimeline(shareData)
          })
          wx.error(function(error){
            //console.log(error)
          })
        })
      }
    }
  }
</script>

<style scoped>
  .article{
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    overflow: hidden;
  }
  .article .h3{
    padding: 0 10px;
    font-size: 17px;
    line-height: 28px;
    font-weight: normal;
    margin-top:15px;
    margin-bottom: 5px;
  }
  .source{
    overflow: hidden;
    margin-bottom: 15px;
    padding:0 10px;
  }
  .source .s-1{
    font-size: 14px;
    color: #888686;
  }
  .source .s-2{
    margin-left: 15px;
    font-size: 14px;
    color: #888686;
  }
  .article .content{
    padding:0 10px;
  }
  .article .content img{
    display: block;
    max-width: 100% !important;
  }
  .article .content p{
    margin: 0;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/scheme/details.vue